import React, { useRef, useEffect } from 'react';

const AutoResizingTextarea = (props) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      const timer = setTimeout(() => {
        textareaRef.current.style.height = 'auto';
        const newHeight = Math.min(textareaRef.current.scrollHeight + 2, 500);
        textareaRef.current.style.height = `${newHeight}px`;
      }, 0);
      return () => clearTimeout(timer);
    }
  }, [props.value]);

  return <textarea ref={textareaRef} {...props} />;
};

export default AutoResizingTextarea;
